<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search" @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="类型分类">
              <el-select clearable class="ele-block" v-model="where.channel_type_id" placeholder="请选择">
                <el-option v-for="item in channeltypeList" :key="item.id" :value="item.id" :label="item.channel_name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="通道名称">
              <el-input clearable v-model="where.up_channel_name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="控制器名">
              <el-input clearable v-model="where.code_name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询
              </el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <!-- 表头工具栏 -->
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">添加
          </el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!selection.length" @click="removeBatch">删除
          </el-button>
        </template>
        <!-- 类型列 -->
        <template slot="type" slot-scope="{ row }">
          <el-tag v-if="row.type_id === 1" type="success" size="small">S</el-tag>
          <el-tag v-if="row.type_id === 2" type="success" size="small">F</el-tag>
          <el-tag v-if="row.type_id === 3" type="success" size="small">N</el-tag>
        </template>
        <!-- 状态 -->
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"></el-switch>
        </template>
        <!-- is_lx -->
        <template slot="is_lx" slot-scope="{ row }">
          <el-switch v-model="row.is_lx" @change="editLx(row)" :active-value="1" :inactive-value="2"></el-switch>
        </template>
        <!-- 操作列 -->
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" :underline="false" @click="openEdit(row)">
            编辑
          </el-button>
          <el-popconfirm class="ele-action" title="确定要删除此通道吗？" @confirm="remove(row)">
            <el-button size="small" type="danger" class="ele-btn-icon" :underline="false" slot="reference">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <column-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import ColumnEdit from "./column-edit";

export default {
  name: "channelCloumn",
  components: {
    ColumnEdit,
  },
  data() {
    return {
      // 表格数据接口
      url: "/channelcolumn/index",
      // 表格列配置
      columns: [
        {
          columnKey: "selection",
          type: "selection",
          width: 45,
          align: "center",
          fixed: "left",
        },
        {
          prop: "id",
          label: "序号",
          width: 60,
          align: "center",
          showOverflowTooltip: true,
          fixed: "left",
        },
        {
          prop: "type_id",
          label: "类型分类",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
          slot: "type",
        },
        {
          prop: "channel_name",
          label: "通道名称",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
        },
        {
          prop: "classname",
          label: "小组名称",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
        },
        {
          prop: "up_channel_name",
          label: "通道名称",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
        },
        {
          prop: "code_name",
          label: "控制器名",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
        },
        {
          prop: "money_gz",
          label: "金额规则",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
        },
        {
          prop: "status",
          label: "通道开关",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
          slot: "status",
        },
        {
          prop: "is_lx",
          label: "轮询开关",
          showOverflowTooltip: true,
          minWidth: 100,
          align: "center",
          slot: "is_lx",
        },
        {
          columnKey: "action",
          label: "操作",
          width: 200,
          align: "center",
          resizable: false,
          slot: "action",
          fixed: "right",
        },
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      // 当前编辑数据
      current: null,
      // 是否显示编辑弹窗
      showEdit: false,
      // 渠道分类列表
      channeltypeList: [],
    };
  },
  mounted() {
    this.queryChannelType();  // 渠道分类列表
  },
  methods: {
    /* 刷新表格 */
    reload() {
      this.$refs.table.reload({
        where: this.where,
      });
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.reload();
    },
    /* 显示编辑 */
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    /* 删除 */
    remove(row) {
      const loading = this.$loading({
        lock: true,
      });
      this.$http
        .post("/channelcolumn/delete", {
          id: row.id,
        })
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    /* 渠道分类列表 */
    queryChannelType() {
      this.$http.get('/Channeltype/getchannelTypeList').then(res => {
        if (res.data.code === 0) {
          this.channeltypeList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error("请选择");
        return;
      }
      this.$confirm("确定要删除选中的币种吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
          });
          this.$http
            .post("/channelcolumn/delete", {
              id: this.selection.map((d) => d.id),
            })
            .then((res) => {
              loading.close();
              if (res.data.code === 0) {
                this.$message.success(res.data.msg);
                this.reload();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        })
        .catch(() => { });
    },
    // 行状态改变
    editStatus(row) {
      const loading = this.$loading({
        lock: true,
      });
      let params = Object.assign({
        id: row.id,
        status: row.status,
      });
      this.$http
        .post("/channelcolumn/status", params)
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            row.status = row.status != 1 ? 1 : 2;
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    // 修改单行轮询
    editLx(row) {
      const loading = this.$loading({
        lock: true,
      });
      let params = Object.assign({
        id: row.id,
        is_lx: row.is_lx,
      });
      this.$http
        .post("/channelcolumn/edit", params)
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            row.is_lx = row.status != 1 ? 1 : 2;
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
  },
};
</script>

<style scoped></style>
